import { LitElement, html, css } from 'lit';

class TemplateSearchResult extends LitElement {
    static get properties() {
        return {
            pageTitle: { type: String },
            componentName: { type: String },
            toElement: { type: String }
        };
    }

    static get styles() {
        return css`
            :host {
                display: block;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                overflow: hidden;
                margin: 10px 5px;
                border: 1px solid #cbc9c9;
            }
            .search-result-header {
                background-color: rgb(129, 167, 255);
                color: rgb(255, 255, 255);
                padding: 5px 10px;
                white-space: nowrap; /* テキストを折り返さないように指定 */
                overflow: hidden; /* テキストが溢れた場合、非表示に指定 */
                text-overflow: ellipsis; /* テキストが溢れた場合に「…」を表示 */
            }
            .search-result-body {
                padding: 5px;
                background-color: #f9f9f9;
                color: #67834f;
            }

            .search-result-body p {
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                margin: 0;
                padding: 0 10px;
            }
            
            .search-result-body p span {
                white-space: nowrap; /* テキストを折り返さないように指定 */
                overflow: hidden; /* テキストが溢れた場合、非表示に指定 */
                text-overflow: ellipsis; /* テキストが溢れた場合に「…」を表示 */
                flex-grow: 1; /* テキスト部分が利用可能なスペースを最大限に使用するように設定 */
            }
            
            .search-result-body p i {
                flex-shrink: 0; /* アイコンが縮小されないように設定 */
                cursor: pointer;
            }

        `;
    }

    constructor() {
        super();
        this.pageTitle = '';
        this.componentName = '';
        this.toElement = '';
    }

    firstUpdated() {
        //アニメーションフレーム
        requestAnimationFrame(() => {
            const fontAwasomeStyle = document.querySelector(
                "link[rel='stylesheet'][data-name='fontawesomev6']"
            );
            const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
            fontAwasomeStyleClone.removeAttribute('disabled');
            this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
        });
    }

    handleToElement() {
        window.dispatchEvent(new CustomEvent('to-element-and-select',
            {
                detail: this.toElement,
                bubbles: true,
                composed: true,
            }
        ));
    }

    render() {
        return html`
            <div class="card">
                <div class="search-result-header">${this.pageTitle}</div>
                <div class="search-result-body">
                    <p>
                        <span>${this.componentName}</span>
                        <i class="fa-solid fa-arrow-up-right-from-square" @click="${this.handleToElement}"></i></p>
                </div>
            </div>
        `
    }
}

customElements.define('template-search-result', TemplateSearchResult);